// extracted by mini-css-extract-plugin
export default {"container":"Nea-z","creativeContainer":"Oea-z","copy":"Pea-z","cta":"Qea-z","disabled":"Rea-z","flipped":"Sea-z","productCard":"Tea-z"};